import userConstants    from './user.constants';
import userInitialState from './user.state';

function userReducer(state = userInitialState, action) {
  switch (action.type) {
    case userConstants.GET_REACTIVATION_LINK_REQUEST:
    case userConstants.GET_USER_INFO_REQUEST:
    case userConstants.PROFILE_GET_INITIAL_STATE_REQUEST:
    case userConstants.USER_DELETE_REQUEST:
    case userConstants.USER_LOGIN_REQUEST:
    case userConstants.USER_LOGOUT_REQUEST:
    case userConstants.USER_REGISTER_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case userConstants.USER_CHANGE_LOCATION_REQUEST:
      state = {
        ...state,
        loading:         true,
        locationLoading: true,
      };
      break;

    case userConstants.GET_USER_INFO_SUCCESS:
      state = {
        ...state,
        authorized:    action.authorized || false,
        appealTypes:   action.appealTypes || state.appealTypes,
        bookmarks:     action.bookmarks || state.bookmarks,
        cityLabel:     action.cityLabel || state.cityLabel,
        email:         action.email,
        roles:         action.roles,
        possibleRoles: action.possibleRoles,
        name:          {
          first_name: action.first_name || null,
          last_name:  action.last_name || null,
          patronymic: action.patronymic || null,
        },
        address:       action.address || null,
        phone:         action.phone || null,
        regions:       action.regions || [],
        cities:        action.cities || [],

        userInitialStateLoaded: true,
        loading:                false,
      };
      break;

    case userConstants.GET_REACTIVATION_LINK_FAILURE:
    case userConstants.GET_REACTIVATION_LINK_SUCCESS:
    case userConstants.GET_USER_INFO_FAILURE:
    case userConstants.PROFILE_GET_INITIAL_STATE_FAILURE:
    case userConstants.USER_DELETE_FAILURE:
    case userConstants.USER_DELETE_SUCCESS:
    case userConstants.USER_REGISTER_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case userConstants.USER_CHANGE_LOCATION_FAILURE:
      state = {
        ...state,
        loading:         false,
        locationLoading: false,
      };
      break;

    case userConstants.GET_AUTH_TOKEN_SUCCESS:
      state = {
        ...state,
        _token: action._token,
      };
      break;

    case userConstants.USER_REGISTER_SUCCESS:
      state = {
        ...state,
        authorized: action.authorized || false,

        email:   action.email,
        roles:   action.roles,
        name:    {
          first_name: action.first_name,
          last_name:  action.last_name,
          patronymic: action.patronymic,
        },
        address: action.address,

        loading: false,
      };
      break;

    case userConstants.USER_LOGIN_SUCCESS:
      state = {
        ...state,
        authorized: true,
        isActive:   action.isActive,

        email:        action.email,
        role:         action.role,
        name:         {
          first_name: action.first_name,
          last_name:  action.last_name,
          patronymic: action.patronymic,
        },
        address:      action.address,
        location:     !!action.location ? {
          cityId: +action.location.cityId || null,
          label:  action.location.label || null,
        } : { ...userInitialState.location },
        probablyCity: !!action.probablyCity ? {
          cityId: +action.probablyCity.cityId || null,
          label:  action.probablyCity.label || null,
        } : { ...userInitialState.probablyCity },
        regions:      action.regions || [],
        cities:       action.cities || [],

        loading: false,
      };
      break;

    case userConstants.USER_LOGIN_FAILURE:
      state = {
        ...state,
        loading:  false,
        isActive: action.isActive,
      };
      break;

    case userConstants.USER_LOGOUT_SUCCESS:
      state = { ...userInitialState };
      break;

    case userConstants.USER_CHANGE_LOCATION_SUCCESS:
      state = {
        ...state,
        authorized:    action.authorized || false,
        bookmarks:     action.bookmarks || state.bookmarks,
        email:         action.email,
        roles:         action.roles,
        possibleRoles: action.possibleRoles,
        name:          {
          first_name: action.first_name || null,
          last_name:  action.last_name || null,
          patronymic: action.patronymic || null,
        },
        address:       action.address || null,
        phone:         action.phone || null,
        location:      !!action.location ? {
          cityId: +action.location.cityId || null,
          label:  action.location.label || null,
        } : { ...userInitialState.location },
        regions:       action.regions || [],
        cities:        action.cities || [],

        loading:         false,
        locationLoading: false,
      };
      break;

    case userConstants.USER_GET_LOCATION_REQUEST:
      state = {
        ...state,
        locationLoading: true,
      };
      break;

    case userConstants.USER_GET_LOCATION_SUCCESS:
      state = {
        ...state,
        probablyCity:    !!action.probablyCity ? {
          cityId: +action.probablyCity.cityId || null,
          label:  action.probablyCity.label || null,
        } : { ...userInitialState.probablyCity },
        locationLoading: false,
      };
      break;

    case userConstants.USER_GET_LOCATION_FAILURE:
      state = {
        ...state,
        locationLoading: false,
      };
      break;

    case userConstants.PROFILE_GET_INITIAL_STATE_SUCCESS:
      state = {
        ...state,
        form:                      { ...action.data || userInitialState.form },
        loading:                   false,
        profileInitialStateLoaded: true,
      };
      break;

    case userConstants.PROFILE_SUBMIT_ACCOUNT_DATA_REQUEST:
    case userConstants.PROFILE_SUBMIT_USER_DATA_REQUEST:
      state = {
        ...state,
        wait: true,
      };
      break;

    case userConstants.PROFILE_SUBMIT_USER_DATA_SUCCESS:
      state = {
        ...state,
        form: { ...action.data } || state.form,
        wait: false,
      };
      break;

    case userConstants.PROFILE_SUBMIT_ACCOUNT_DATA_SUCCESS:
    case userConstants.PROFILE_SUBMIT_USER_DATA_FAILURE:
    case userConstants.PROFILE_SUBMIT_ACCOUNT_DATA_FAILURE:
      state = {
        ...state,
        wait: false,
      };
      break;

    case userConstants.ADD_TO_BOOKMARKS_SUCCESS:
      state = {
        ...state,
        bookmarks: action.bookmarks || state.bookmarks,
      };
      break;

    case userConstants.REMOVE_BOOKMARKS:
      state = {
        ...state,
        bookmarks: {},
      };
      break;

    case userConstants.GET_APPEAL_TOKEN_REQUEST:
      state = {
        ...state,
        appealLoading: true,
      };
      break;

    case userConstants.GET_APPEAL_TOKEN_SUCCESS:
      state = {
        ...state,
        tokenList:                {
          ...state.tokenList,
          [action.appealType]: action._token,
        },
        appealInitialStateLoaded: true,
        appealLoading:            false,
      };
      break;

    case userConstants.GET_APPEAL_TOKEN_FAILURE:
      state = {
        ...state,
        appealLoading: false,
      };
      break;

    case userConstants.SEND_APPEAL_REQUEST:
      state = {
        ...state,
        appealWait: true,
      };
      break;

    case userConstants.SEND_APPEAL_SUCCESS:
    case userConstants.SEND_APPEAL_FAILURE:
      state = {
        ...state,
        appealWait: false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default userReducer;